<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="contactForm">
    <mat-form-field class="w-100">
      <mat-label>Contact Type</mat-label>
      <mat-select [formControlName]="controls.ContactTypeCode"
                  [required]="true"
                  (selectionChange)="onContactTypeCodeChanged($event.value)">
        <mat-option *ngFor="let contactTypeCode of contactTypeCodes" [value]="contactTypeCode.key">
          {{contactTypeCode.value}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    
    <div *ngIf="showValueField">
      <app-element-input
        [label]="valueHeading"
        [hint]="valueHint()"
        [required]="true"
        [cssClasses]="['w-100']"
        [formControlName]="controls.ContactValue">
      </app-element-input>
    </div>
    
    <mat-slide-toggle [formControl]="contactForm.controls[controls.IsPreferred]">
      <span>Is Preferred</span>
    </mat-slide-toggle>
  </form>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
  <button class="dialog-button" mat-raised-button color="primary"
          [disabled]="!contactForm.valid"
          (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>